import React, { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { NavbarContext } from "../../context";
import { HeroIntro } from "./components/HeroIntro";
import { HeroStats } from "./components/HeroStats";
import { scrollToSection } from "../../utils/scrollToSection";

export const Home = () => {
  const { ref: sectionRef, inView: sectionInView } = useInView({ threshold: 0.4 });
  const setPage = useContext(NavbarContext);

  useEffect(() => {
    if (sectionInView) setPage("home");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionInView]);

  return (
    <section
      ref={sectionRef}
      id="home-page"
      className="hero-section"
      aria-label="Introduction"
    >
      <div className="container-wide">
        <HeroIntro scrollToProjects={() => scrollToSection("projects-page")} />
        <HeroStats />
      </div>
    </section>
  );
};
